import React from "react";
import {
  BodyAsFormData,
  filterDataFromUrl,
} from "../../../services/utilities/util";
import FilterContext from "../../../routes/FilterContext";
import { apiMiddleware } from "../../../services/apis/apiMiddleware";
import "leaflet/dist/leaflet.css";
import * as L from "leaflet";
import { MapContainer, Marker, Popup, TileLayer } from "react-leaflet";
import { connect } from "react-redux";
import MarkerClusterGroup from "react-leaflet-markercluster";
import markerIconPng from "leaflet/dist/images/marker-icon.png";
import { Icon, latLngBounds } from "leaflet";
function mapStateToProps(state) {
  return { filters: state.selectedFilters };
}

class RegionMap extends React.Component {
  static contextType = FilterContext;

  state = {
    markers: [],
    filters: "",
    bounds: null,
  };

  componentDidMount() {
    var filters;
    if (JSON.stringify(this.props.filters) == "{}") {
      filters = JSON.stringify(this.context.filters);
    } else {
      filters = JSON.stringify(this.props.filters);
    }
    this.state.filters = filters;

    apiMiddleware
      .post("api/edge/office/get_buildings_on_map", BodyAsFormData(filters))
      .then((res) => {
        this.state.bounds = latLngBounds([
          res.data.latitude,
          res.data.longitude,
        ]);
        for (let i = 0; i < res.data.length; i++) {
          this.state.bounds.extend([
            res.data[i].latitude,
            res.data[i].longitude,
          ]);
        }
        this.setState({ markers: res.data });
      });
  }

  componentDidUpdate() {
    if (this.props.filters != this.state.filters){
      this.setState({ filters: this.props.filters });

      apiMiddleware
        .post(
          "api/edge/office/get_buildings_on_map",
          BodyAsFormData(JSON.stringify(this.props.filters))
        )
        .then((res) => {
          this.state.bounds = latLngBounds([
            res.data.latitude,
            res.data.longitude,
          ]);
          for (let i = 0; i < res.data.length; i++) {
            this.state.bounds.extend([
              res.data[i].latitude,
              res.data[i].longitude,
            ]);
          }
          this.setState({ markers: res.data });
          console.log(this.state.bounds);
        });
    }
  }

  render() {
    return (
      this.state.markers.length > 0 && (
        <MapContainer bounds={this.state.bounds} scrollWheelZoom={true}>
          <TileLayer
            attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
            url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
          />
          <MarkerClusterGroup>
            {this.state.markers.length > 0 &&
              this.state.markers.map((marker) => (
                <Marker
                  position={[marker.latitude, marker.longitude]}
                  icon={
                    new Icon({
                      iconUrl: markerIconPng,
                      iconSize: [25, 41],
                      iconAnchor: [12, 41],
                    })
                  }
                >
                  <Popup>{marker.complex}</Popup>
                </Marker>
              ))}
          </MarkerClusterGroup>
        </MapContainer>
      )
    );
  }
}

export default connect(mapStateToProps)(RegionMap);
